import {
  Card,
  CardActions,
  CardContent,
  CardMedia,
  Typography,
} from "@material-ui/core";
import React from "react";
import { toAbsoluteUrl } from "../../../_metronic/_helpers";
import styled from "styled-components";

const Container = styled.div`
  width: 100%;
  height: 100%;
  margin: 0px;
  position: relative;

  padding: 0;

  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
`;

const Logo = styled.img`
  margin-left: auto;
  margin-right: auto;
  max-width: 330px;
  max-height: 330px;
`;

const Header = styled.div`
  background-image: linear-gradient(180deg, #40da7a, #0f8e40) !important;;
  border: none;
  min-height: 290px;
  height: auto;
  text-align: center;
  color: white;
  justify-content: center;
  padding: 55px 50px 75px 50px;
  margin: 0px;
  font-size: 20px;
`;

const HeaderText = styled.p``;

const Cards = styled.div`
  height: 100%;
  position: relative;
  margin: 10%;
  margin-top: -14rem;
  padding: 0px;
`;

const SingleCard = styled.div`
  min-height: 270px;
  height: auto;
  background: #e9e9e9;
  background: linear-gradient(180deg, white, #e4e3e3);

  -webkit-box-shadow: 0px 0px 25px 2px rgba(49, 46, 14, 0.38);
  box-shadow: 0px 3px 5px 2px rgba(49 46 14 / 10%);

  flex: 1;
  top: 80px;
  margin: 40px;
  padding: 5px;
  border-radius: 20px;

  position: relative;
  justify-content: center;
  align-items: center;
  text-align: center;
`;

const IConContainer = styled.div`
  top: -20%;
  position: absolute;
  left: 0;
  right: 0;
`;

const Icon = styled.img`
  max-width: 10rem;
  height: auto;

  object-fit: contain;

  margin: 10px;
`;

const Title = styled.h1`
  font-size: 18px;
  margin-top: 100px;
  color: #7d7d80;
  font-weight: bold;
`;

const Text = styled.p`
  font-size: 15px;
  margin-top: 20px;
  color: #7d7d80;
`;

function LandingPage() {
  return (
    <Container>
      {/* box-shadow: inset 100px 0px 100px -50px #D4D4CC, inset -100px 0px 100px -50px #D4D4CC; */}
      <div className="d-flex flex-wrap justify-content-center">
        <Logo
          className="col-12 col-md-5"
          src={toAbsoluteUrl("./media/landings/Assets/ebus.png")}
        />
      </div>
      <Header>
        <HeaderText>
          سال هاست که حمل و نقل عمومی اتوبوسی در کشور ایران مشغول به فعالیت است
          و شرکت های حمل و نقل بسیاری در این زمینه فعالیت می کنند
          <br />
          و با توجه به تجربه شما در این سال ها طبیعی است که برای سفر با اتوبوس
          به روش های سنتی شرکت های فعلی را برای سفر انتخاب کنید.
          <br />
          اما برای پاسخ به سوالات احتمالی شما که چرا ایباس؟
          <br />
        . ایباس برای ایجاد یک تغییر آمده و قصد تغییر در جزئیاتی که گاهی فراموش می شود و رسیدگی به آن ها منجر به تجربه ای لذت بخش از سفر می شود را دارد<div className=""></div>
          
        </HeaderText>
      </Header>
      <Cards>
        <div className="row">
          <SingleCard>
            <IConContainer>
              <Icon alt="money" src={toAbsoluteUrl("./media/landings/Assets/money.png")} />
            </IConContainer>
            <Title>ارزون ولی با کیفیت</Title>
            <Text>
              ایباس شانس تجربه یک سفر ارزون رو به شما میده!
              <br />
              امکان سفر مقرون به صرفه با بلیط های همیشه تخفیف ایباس. قبل از خرید
              قیمت بلیط هارا مقایسه کنید.
            </Text>
          </SingleCard>
        </div>
        {/* <SingleCard> */}
        <div className="row">
          <div className="col-12 col-md-6">
            <SingleCard>
              <IConContainer>
                <Icon src={toAbsoluteUrl("./media/landings/Assets/time.png")} />
              </IConContainer>
              <Title>وقت طلاست البته با ایباس</Title>
              <Text>
                اتلاف وقت هزینه داره. با ایباس مدیریت زمان و سفر با خود شماست.
              </Text>
            </SingleCard>
          </div>
          <div className="col-12 col-md-6">
            <SingleCard>
              <IConContainer>
                <Icon
                  src={toAbsoluteUrl("./media/landings/Assets/discount.png")}
                />
              </IConContainer>
              <Title>هیجان سفر با ایباس</Title>
              <Text>
                با چرخ هیجان ایباس بچرخ / پیشنهادات هیجان انگیز / تخفیف های
                دایمی
              </Text>
            </SingleCard>
          </div>
        </div>
        {/* </SingleCard> */}
        <div className="row">
          <SingleCard>
            <IConContainer>
              <Icon
                src={toAbsoluteUrl("./media/landings/Assets/Artboard.png")}
              />
            </IConContainer>
            <Title>بلیط خریداری شده از ایباس پس گرفته می شود.</Title>
            <Text>
              استرداد بلیط سفر تا آخرین لحظه قبل از شروع سفر
              <br />
              تا یک ساعت قبل از شروع سفر : کسر ۱۰ درصد از قیمت بلیط
              <br />
              کمتر از یک ساعت مانده قبل از شروع سفر کسر ۵۰ درصد از قیمت بلیط
            </Text>
          </SingleCard>
        </div>
        <div className="row">
          <div className="col-12 col-md-6">
            <SingleCard>
              <IConContainer>
                <Icon
                  src={toAbsoluteUrl("./media/landings/Assets/calendar.png")}
                />
              </IConContainer>
              <Title>رزرو بلیط زودهنگام</Title>
              <Text>
                برنامه سفر یک سال آینده رو با ایباس ببند. امکان خرید
                <br />
                بلیط زودتر از زمان سفر و رزرو اون با قیمت پایین تر
              </Text>
            </SingleCard>
          </div>
          <div className="col-12 col-md-6">
            <SingleCard>
              <IConContainer>
                <Icon
                  src={toAbsoluteUrl("./media/landings/Assets/online.png")}
                />
              </IConContainer>
              <Title>خدمات آنلاین بدون نیاز به حضور شما</Title>
              <Text>
                رزرو بلیط سفر با اتوبوس های ایباس از طریق
                <br />
                اپلیکیشن و سایت
              </Text>
            </SingleCard>
          </div>
        </div>
      </Cards>
    </Container>
  );
}

export default LandingPage;
